import React from "react";

import BaseGrid from "../../../components/BaseGrid";
import ViewDetailButton from "./ViewDetailButton";

import { Category } from "../data/Category";

import { ColDef, RowDoubleClickedEvent, SelectionChangedEvent } from "ag-grid-community";

import { useCategoryContext } from "../context/CategoryContext";
import { useCategoryGridStore } from "../store/CategoryGridStore";
import { useCategoryDrawerStore } from "../store/CategoryDrawerStore";

export default function CategoryGrid() {
    const { categories, isCategoriesFetching } = useCategoryContext();
    const { openEdit } = useCategoryDrawerStore();
    const { setSelectedCategories } = useCategoryGridStore();

    const colDefs = React.useMemo<ColDef[]>(() => {
        return [
            {
                field: "id",
                headerName: "ID",
                filter: true,
                minWidth: 95,
                maxWidth: 105,
            },
            {
                field: "name",
                headerName: "Name",
                minWidth: 200,
            },
            {
                field: "details",
                headerName: "Details",
                cellRenderer: ViewDetailButton,
                maxWidth: 130,
                valueGetter: (params) => {
                    return params.data as Category;
                }
            }
        ];
    }, []);

    const handleRowDoubleClick = React.useCallback((e: RowDoubleClickedEvent) => {
        const category = e.data as Category;
        openEdit(category);
    }, [openEdit]);

    const onSelectionChanged = React.useCallback((e: SelectionChangedEvent) => {
        setSelectedCategories(e.api.getSelectedRows() as Category[]);
    }, [setSelectedCategories]);

    const onReset = React.useCallback(() => {
        setSelectedCategories([]);
    }, [setSelectedCategories]);

    return (
        <BaseGrid<Category>
            isSingle={true}
            isLoading={isCategoriesFetching}
            data={categories}
            colDefs={colDefs}
            onRowDoubleClick={handleRowDoubleClick}
            onSelectionChanged={onSelectionChanged}
            onReset={onReset}
        />
    );
}
